import NomadApiClient from '@/pages/api/api-clients/nomad-api';
import { orderBy } from '@/utils/array-utils';

export type Region = {
  id: string;
  name: string;
};

const get = async () => {
  const response = await NomadApiClient.get<Region[]>('/region', {
    params: {
      states_only: true,
    },
    transformResponse: (response) => JSON.parse(response).data,
  });

  return orderBy(response.data, (region) => region.name);
};

const RegionsService = {
  get,
};

export default RegionsService;
